import API from 'services/api';

export const updateCompanyDetails = ({ payload }: { payload: any }) =>
  API.put(`/api/profile/company-settings`, payload);
